import { getMarketData } from '@utils/getMarketData';
import { useMemo } from 'react';
import { useMarketNameContext } from './useMarketName';

export default function useLocale() {
    const marketName = useMarketNameContext();
    return useMemo(() => getMarketData(marketName), [marketName]);
}
